/**
 * PursuitLayoutContext
 *
 * Signals whether the pursuit lifecycle stepper has been promoted to the
 * layout top bar (pursuit focus mode). When topBarActive is true, every
 * inline <PursuitLifecycleStepper /> suppresses itself so the top-bar
 * instance is the single source of truth.
 */
import { createContext, useContext } from 'react';

export const PursuitLayoutContext = createContext({ topBarActive: false });

export function usePursuitLayout() {
  return useContext(PursuitLayoutContext);
}
